export const styles = theme => ({
    endListDivider: {
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    listContainer: theme.listContainer,
    addDeviceDialog: {
        '& .dialogContent.topSeparation': {
            paddingTop: 65,
        },
        '& .tabContainer': {
            position: 'absolute',
            zIndex: 1000,
            top: 65,
            right: 10,
            left: 10,
            backgroundColor: '#fafafa',
            paddingTop: 10,
            marginTop: '0px !important',
            [theme.breakpoints.up('sm')]: {
                width: '95%',
            },
        },
    },
    modalDialog: theme.dialogDimentions,
    devicesByModelContainer: {
        '& .modelInput': {
            marginLeft: 20,
            display: 'block',
            '& > div': {
                width: '100%',
            }
        },
        '& .modelLocationTip': {
            color: '#4A90E2',
            fontSize: '13px',
            margin: '5px 20px 20px 23px',
        }
    },
    grid: {
        display: 'flex',
        flexDirection: 'column',
    },
    itemButton: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        paddingBottom: '5px',
        marginBottom: '15px'
    },
    itemsPaper: {
        backgroundColor: 'white !important',
        padding: '12px 20px',
        [theme.breakpoints.up('md')]: {
            padding: '25px 15px',
        }
    },
    fab: {
        position: 'fixed',
        bottom: theme.spacing.unit * 1,
        right: theme.spacing.unit * 2,
        [theme.breakpoints.up('md')]: {
            bottom: theme.spacing.unit * 10,
            right: theme.spacing.unit * 15,
        },
    },
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    notificationsIcon: {
        width: '50px',
        height: '50px',
    },
    transparentAvatar: {
        backgroundColor: 'transparent',
        width: 50,
        height: 50,
        display: 'block',
    },
    addDialogFabButton: {
        position: 'fixed',
        bottom: 20,
        right: 20,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    itemMainDiv: {
        display: 'flex',
        flexWrap: 'noWrap',
        flexDirection: 'column',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        }
    },
    itemHeader: {
        display: "flex",
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: -10,
        [theme.breakpoints.up('md')]: {
            flexDirection: 'column',
            minWidth: '120px',
            marginLeft: 'initial',
        },
    },
    separator: {
        display: 'flex',
        flexGrow: 1,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        },
    },
    issuesDesktop: {
        display: 'flex',
        flexWrap: 'wrap-reverse',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginTop: '15px',
        [theme.breakpoints.up('md')]: {
            display: 'block',
            flexGrow: 1,
            marginLeft: '15px',
            marginRight: '5px',
            marginTop: 0,
        },
    },
    deleteButtonMovil: {
        display: 'inline',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    deleteButtonDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'inline'
        }
    },
    itemTitle: {
        marginLeft: '5px',
        marginRight: '10px',
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            marginLeft: 0,
            marginRight: 0,
        }
    },
    issueChip: {
        height: 'auto',
        paddingTop: '5px',
        paddingBottom: '5px',
        width: '100%',
        margin: '1px',
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: 600,
        flexWrap: 'nowrap',
        marginBottom: '5px',
        marginLeft: 'initial',
        [theme.breakpoints.up('md')]: {
            width: 'auto',
            display: 'inline-flex',
            marginRight: '5px',
            marginBottom: '3px',
        }
    },
    emptyTypography: {
        fontSize: 14,
        marginTop: '20px',
        color: 'rgba(0, 0, 0, 0.40)',
    },
    buttonCard: {
        boxShadow: theme.shadows[2],
        borderRadius: '50%',
        paddingBottom: '0px',
        paddingTop: '0px',
        paddingLeft: 0,
        display: 'block',
        zIndex: 0,
        overflow: 'hidden',
    },
    colorPaper: {
        display: 'inherit',
        backgroundColor: 'white',
        padding: '2.5px',
        [theme.breakpoints.up('sm')]: {
            padding: '5px',
        },
    },
    colorName: {
        fontSize: '12px',
        marginLeft: '3px'
    },
    otherChip: {
        display: 'inline-block',
        marginTop: '10px',
        marginBottom: '5px',
        marginLeft: '5px',
        [theme.breakpoints.down('md')]: {
            marginLeft: '5px',
            alignSelf: 'flex-start',
        }
    }
});
